import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useAppEvenListSelector, useAppRodeoEventSettingsSelector } from "src/_common/hooks/selectors/eventSelector";
import { useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import { CRYPTO_SECRET_KEY, URLS } from "src/_config";
import Sponsor from "src/components/common/Sponsor";
import Cryptr from "cryptr";
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function PrizesListPage() {
  const history = useHistory();
  const { eventId, performanceId } = useParams<{ eventId?: string; performanceId?: string }>();
  const rodeoEventSettings = useAppRodeoEventSettingsSelector() as Record<string, number | boolean> | null;
  const types = ["Game", "Task", "Performance"];
  const eventList = useAppEvenListSelector() as { list?: Array<{ id: string; login_required?: number }> } | null;
  const userDetails = useAppUserDetailsSelector();

  const gotoPrizeDetailsPage = (type: string) => {
    history.push(`/prize/${eventId}/${performanceId}/${cryptr.encrypt(type)}`);
  };

  const gotoEventPage = () => {
    const e_id = cryptr.decrypt(eventId || '');
    const loginReq = eventList?.list?.find((x: { id: string; login_required?: number }) => x.id == e_id)?.login_required;
    if (userDetails || loginReq == 0) {
      history.push(`/event/${eventId}/${performanceId}`);
    } else {
      history.push(`${URLS.LOGIN}`);
    }
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <React.Fragment>
      <h2 className="page-title text-left">
        <a onClick={goBack} className="back-history">
          <img src="/images/left-white.svg" alt="back" />
        </a>
        Prizes
        <hr className="color-white" />
      </h2>
      <ul className="list-style rodeo-inside-list mt-4">
        {types.map((type: string, i: number) =>
          rodeoEventSettings && rodeoEventSettings["is_" + (type == "Task" ? "event" : type.toLowerCase()) + "_prize"] ? (
            <li key={i}>
              <a className={"ripple-effect d-flex"} onClick={() => gotoPrizeDetailsPage(type)}>
                <span>
                  <i
                    className={type == "Game" ? "fas fa-trophy" : type == "Performance" ? "fa fa-shield" : "fa fa-flag"}
                    style={{ fontSize: "25px" }}
                  />
                </span>
                <span className="event-info">
                  <span className="d-inline-block event-title">{type} Prize</span>
                </span>
              </a>
            </li>
          ) : null
        )}
      </ul>
      <div className="join-now-btn-wrap">
        <button className="w-100" onClick={gotoEventPage}>
          Play Now
        </button>
      </div>
      <Sponsor />
    </React.Fragment>
  );
}
